import API from '@/dataAccess/api'
import store from '@/dataAccess/store'
import Employee from '@/dataAccess/models/Employee'
import Service from '@/dataAccess/models/Service'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import LimitedClient from '@/dataAccess/models/LimitedClient'

export async function loadInitialData() {
  await Employee.api().get('employees/')
  /* `LimitedClient` must be called before `AccessibleClient`:
   * the later one overrides existing entries and we want
   * `AccessibleClient` which has more data to override `LimitedClient` not vise verse
   */
  await LimitedClient.api().get('limited-clients/')
  await AccessibleClient.api().get('clients/')
  await Service.api().get('services/')
}

async function getAndStoreData(apiCall, actionName) {
  const apiResponse = await apiCall.bind(API)()
  await store.dispatch(actionName, Employee.apiResponseMapper(apiResponse.data))
}

export async function getCurrentUser() {
  await getAndStoreData(API.getUser, 'storeUser')
}
